<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep } from "lodash";
import groupBy from "lodash/groupBy";
import DatePicker from "vue2-datepicker";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RSMIGeneration from "@/components/widgets/rsmigeneration.vue";
import RawData from "@/components/widgets/raw-data.vue";
import RequisitionModal from "@/components/modals/requisition-modal.vue";
import PropertyModal from "@/components/modals/property-modal.vue";
import MergeStockModal from "@/components/modals/merge-stock-modal.vue";

export default {
  page: {
    title: "Requisition"
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    UploadPopover,
    PrintOptions,
    RSMIGeneration,
    RawData,
    RequisitionModal,
    PropertyModal,
    MergeStockModal
  },
  data() {
    return {
      title: "Requisition",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Requisition",
          active: true
        }
      ],
      modalTitle: "",
      tableData: [],
      processedDateFilter: "",
      dateRangeIndex: -1,
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      cycle: this.$store.state.data.cycle,
      requisitionIndex: -1,
      itemIndex: -1,
      quantityIndex: -1,
      tabIndex: 0,
      formStock: {
        stockItemId: null,
        description: "",
        debit: 0,
        credit: 0,
        unitCost: "",
        referenceNumber: "",
        iarItemId: null,
        deliveryUnitId: 0,
        stockItemTransactionParentId: 0,
        allowStockInput: false
      },
      currentPageForm: 1,
      employeeDetail: null,
      itemCategory: "",
      stockName: "",
      employeeName: "",
      employeeType: "",
      itemData: null,
      generateAssignmentNumber: true,
      generatePropertyNumber: true,
      setAllEmployee: false,
      selectedDU: null,
      requisitionNumber: "",
      generateRIS: true,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Requisition",
        placement: "lefttop",
        folder: "Requisition"
      },
      fundclusters: [],
      rsmiType: "cluster",
      selectedItems: [],
      selectedPOs: []
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (
        this.processedDateFilter != null &&
        this.processedDateFilter != "" &&
        this.processedDateFilter[0] != null &&
        this.processedDateFilter[1] != null &&
        this.tabIndex != 0
      ) {
        data = data.filter((item) => {
          if (item.requisitionDate) {
            return (
              new Date(item.requisitionDate) >=
                new Date(this.processedDateFilter[0]) &&
              new Date(item.requisitionDate) <=
                new Date(this.processedDateFilter[1])
            );
          }
        });
      }
      if (this.filter.trim() != "" && this.filter) {
        if (this.tabIndex == 0) {
          data = data.filter((item) => {
            if (item.itemName) {
              if (
                item.itemName.toUpperCase().includes(this.filter.toUpperCase())
              )
                return item.itemName
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
            if (item.description) {
              if (
                item.description
                  .toUpperCase()
                  .includes(this.filter.toUpperCase())
              )
                return item.description
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
            if (item.poNumber) {
              if (
                item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
              )
                return item.poNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
          });
        } else {
          data = data.filter((item) => {
            if (item.requisitionNumber) {
              if (
                item.requisitionNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase())
              )
                return item.requisitionNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
            if (item.poNumber) {
              if (
                item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
              )
                return item.poNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
          });
        }
      }
      return data;
    },
    grouped() {
      var array = [];
      var group = groupBy(this.filtered, "poId");
      for (const key in group) {
        array.push({
          poId: key,
          poNumber: group[key][0].poNumber,
          deliveryUnitId: group[key][0].deliveryUnitId,
          deliveryUnit: group[key][0].deliveryUnit,
          requestedBy: group[key][0].requestedBy,
          availableItems: group[key],
          toggleAll: false,
          visible: false,
          addDocu: false,
          attachmentLoading: false,
          requisitionFiles: [],
          viewFile: false
        });
      }
      return array;
    },
    paginated() {
      let data = this.tabIndex == 0 ? this.grouped : this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.tabIndex == 0 ? this.grouped.length : this.filtered.length;
    },
    filteredForm() {
      var currentData = [];
      if (this.formRequisition?.length) {
        let data = this.formRequisition;
        var total = this.currentPageForm;
        currentData = data.slice(total - 1, total);
        if (this.currentPageForm > 1 && currentData.length == 0) {
          total = this.currentPageForm - 1;
          currentData = data.slice(total - 1, total);
        }
      }
      return currentData;
    }
  },
  async created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
    this.getFundClusters();
  },
  methods: {
    changeCampus(data) {
      this.campusId = data.id;
      if (this.tabIndex == 0) {
        this.getAvailable();
      } else if (this.tabIndex == 1) {
        this.getPending();
      } else if (this.tabIndex == 2) {
        this.getApproved();
      } else if (this.tabIndex == 3) {
        this.getCompleted();
      }
    },
    getFundClusters() {
      this.$store
        .dispatch("finance/GetFundCluster")
        .then((res) => {
          this.fundclusters = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting fund clusters!", "error");
        });
    },
    getAvailable() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetSimpleReqAvailable", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.toggleSelected = false;
          });
          console.log(res.data);
          this.tableData = res.data.sort(function(a, b) {
            if (!a.itemName) {
              return -1;
            }
            if (!b.itemName) {
              return +1;
            }
            return a.itemName.localeCompare(b.itemName);
          });
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting available requisitions!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getPending() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionPendingSumarry", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.requisitionItems = [];
            item.editRISNo = false;
            item.risNumberEdit = "";
            item.visible = false;
            item.loading = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.requisitionFiles = [];
            item.viewFile = false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting pending requisition!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getApproved() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionApprovedSumarry", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.requisitionItems = [];
            item.visible = false;
            item.loading = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.requisitionFiles = [];
            item.viewFile = false;
            item.selected = this.selectedPOs.findIndex(x => x.id == item.id) != -1 ? true : false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting approved requisition!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getCompleted() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionCompletedSumarry", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.requisitionItems = [];
            item.visible = false;
            item.loading = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.requisitionFiles = [];
            item.viewFile = false;
            item.selected = this.selectedPOs.findIndex(x => x.id == item.id) != -1 ? true : false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting completed requisition!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getRequisitionItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        this.$store
          .dispatch("requisition/GetRequisitionItemSummary", row.id)
          .then((res) => {
            res.data.map(item => {
              item.selected = false;
            })
            row.requisitionItems = res.data;
          });
        setTimeout(() => {
          row.loading = false;
        }, 500);
      }
    },
    selectDate(type) {
      if (type == "Today") {
        this.dateRangeIndex = 0;
        this.$refs.processedDateFilter.currentValue = [new Date(), new Date()];
        this.$refs.processedDateFilter.handleConfirmDate();
      } else if (type == "Yesterday") {
        this.$refs.processedDateFilter.currentValue = [
          new Date(Date.now() - 3600 * 1000 * 24),
          new Date(Date.now() - 3600 * 1000 * 24)
        ];
        this.dateRangeIndex = 1;
        this.$refs.processedDateFilter.handleConfirmDate();
      } else if (type == "Last 7 Days") {
        this.$refs.processedDateFilter.currentValue = [
          new Date(Date.now() - 7 * 24 * 3600 * 1000),
          new Date()
        ];
        this.dateRangeIndex = 2;
        this.$refs.processedDateFilter.handleConfirmDate();
      } else if (type == "This Month") {
        this.$refs.processedDateFilter.currentValue = [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
        ];
        this.dateRangeIndex = 3;
        if (this.$refs.processedDateFilter)
          this.$refs.processedDateFilter.handleConfirmDate();
      } else if (type == "This Year") {
        this.$refs.processedDateFilter.currentValue = [
          new Date(new Date().getFullYear(), 0, 1),
          new Date(new Date().getFullYear() + 1, 0, 0)
        ];
        this.dateRangeIndex = 4;
        this.$refs.processedDateFilter.handleConfirmDate();
      } else if (type == "Custom") {
        this.dateRangeIndex = 5;
      }
    },
    checkDate() {
      if (
        this.processedDateFilter[0] == null &&
        this.processedDateFilter[1] == null
      ) {
        this.processedDateFilter = "";
        this.dateRangeIndex = -1;
      }
    },
    async onCreate(modalData) {
      if(modalData.isUpdate){
        let modalForm = modalData.form[0];
        this.$store
          .dispatch("requisition/UpdateRequisitionItem", modalForm)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let reqIndex = this.tableData.findIndex(x => x.id == this.selectedRequisitionId);
            let itemIndex = this.tableData[reqIndex].requisitionItems.findIndex(x => x.id == modalForm.id);
            let updateItem = this.tableData[reqIndex].requisitionItems[itemIndex];
            updateItem.note = modalForm.note;
            updateItem.endUserId = modalForm.endUserId;
            updateItem.accountableOfficer = {
              ...updateItem.accountableOfficer,
              firstName: modalForm.firstName,
              middleName: modalForm.middleName,
              lastName: modalForm.lastName
            }
            this.showToast("Successfully updated!", "success");
            this.$bvModal.hide("req-modal");
          })
          .catch((err) => {
            console.log(err)
            this.showToast(
              "Something went wrong - Updating Requisition!",
              "error"
            );
          });
      }else{
        var props = {
          requisitionItems: modalData.form,
          campusId: this.$store.state.data.selectedCampus.id,
          deliveryUnitId: this.selectedDU || 0,
          requisitionNumber: modalData.requisitionNumber,
          status: "POSTED"
        };
        this.$store
          .dispatch("requisition/CreateRequisition", props)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.getAvailable();
            this.showToast("Successfully created!", "success");
            this.$bvModal.hide("req-modal");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - Creating Requisition!",
              "error"
            );
          });
      }
        
    },
    createRequisition(items) {
      this.selectedDU = items.deliveryUnitId;
      this.$refs.reqModal.resetForm(items.availableItems.filter(x => x.toggleSelected));
      this.modalTitle = "Create Requisition";
      this.$bvModal.show("req-modal");
    },
    onApprove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to approve these items!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, approve it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("requisition/ApproveRequisition", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex((item) => item.id == id);
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully approveed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be posted!", "error");
            });
        }
      });
    },
    updateRequisition(props, requisitionId) {
      this.selectedRequisitionId = requisitionId;
      this.$refs.reqModal.updateFormFromSupply(props);
      this.modalTitle = "Update Requisition";
      this.$bvModal.show("req-modal");
    },
    removeRequisition(props, requisitionId){
      console.log(props, requisitionId); 
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("requisition/UnApproveRequisition", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex(
                (item) => item.id == requisitionId
              );
              var itemIndex = this.tableData[index].findIndex((item) => item.id == props.id);
              this.tableData[index].splice(itemIndex, 1);
              this.showToast("Successfully removed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be removed!", "error");
            });
        }
      });
    },
    undoApprove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, undo approve!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("requisition/UnApproveRequisition", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex((item) => item.id == id);
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully undone", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be undone!", "error");
            });
        }
      });
    },
    onUpdateRISNumber(props) {
      this.submitted = true;
      if (props.risNumberEdit == "") {
        return;
      } else {
        this.$store
          .dispatch("requisition/UpdateRequisitionNumber", {
            id: props.id,
            requisitionNumber: props.risNumberEdit
          })
          .then((res) => {
            if (res.data.error) {
              this.showToast(
                "Cannot update info. " + res.data.errorMessage,
                "error"
              );
              return;
            }
            props.requisitionNumber = cloneDeep(props.risNumberEdit);
            props.editRISNo = false;
            this.showToast("D.R. updated successfully", "success");
          })
          .catch((error) => {
            this.showToast("Something went wrong.", "error");
          });
        this.submitted = false;
      }
    },
    updateRISNumber(props) {
      props.editRISNo = true;
      props.risNumberEdit = cloneDeep(props.requisitionNumber);
    },
    onDelete(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("requisition/DeleteRequisition", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex((item) => item.id == id);
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onCreateProperty(modalData) {
      this.$store
        .dispatch("property/CreatePropertyMultiple", modalData)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.$store
            .dispatch("propertyiar/PostPropertyIar", modalData.iarItemId)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let parIndex = this.tableData.findIndex((item) => item.id == this.selectedRequisitionId);
              let itemIndex = this.tableData[parIndex].requisitionItems.findIndex((item) => item.id == modalData.requisitionItemId);
              this.tableData[parIndex].requisitionItems.splice(itemIndex, 1);
              if (this.tableData[parIndex].requisitionItems.length == 0) {
                this.tableData.splice(parIndex, 1);
              }
              this.showToast("Successfully set!", "success");
              this.$bvModal.hide("modal-property");
            });
        })
        .catch((err) => {
          this.showToast(
            "Something went setting IAR items as property!",
            "error"
          );
        });
    },
    createProperty(props, requisition) {
      this.selectedRequisitionId = requisition.id;
      this.$refs.propModal.onReset(props, requisition);
      this.$refs.propModal.setHeight();
      this.modalTitle = "Create Property";
      this.$bvModal.show("modal-property");
    },
    onMergeStock(modalData) {
      try {
        modalData.status = "POSTED";
        this.$store
          .dispatch("stock/CreateMultipleStockTransaction", [modalData])
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.$store.dispatch("propertyiar/PostPropertyIar", modalData.iarItemId)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                let parIndex = this.tableData.findIndex((item) => item.id == this.selectedRequisitionId);
                let itemIndex = this.tableData[parIndex].requisitionItems.findIndex((item) => item.id == modalData.requisitionItemId);
                this.tableData[parIndex].requisitionItems.splice(itemIndex, 1);
                if (this.tableData[parIndex].requisitionItems.length == 0) {
                  this.tableData.splice(parIndex, 1);
                }
                this.showToast("Successfully set!", "success");
                this.$bvModal.hide("merge-stock-modal");
              });
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong setting items as stock!",
              "error"
            );
          });
        this.submitted = false;
      } catch (error) {
        this.showToast("Something went wrong!", "error");
      }
    },
    mergeStock(props, requisition) {
      this.$refs.stockModal.onReset(props, requisition);
      this.selectedRequisitionId = requisition.id;
      this.modalTitle = "Add to Stock";
      this.$bvModal.show("merge-stock-modal");
    },
    setServices(props, requisition) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to set this item as Services/Consumable",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, set Item!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(
              "inspectioniar/CompleteInspectionIarItem",
              props.iarItemId
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var requisitionIndex = this.tableData.findIndex(
                (item) => item.id == requisition.id
              );
              var itemIndex = this.tableData[
                requisitionIndex
              ].requisitionItems.findIndex((item) => item.id == props.id);
              this.tableData[requisitionIndex].requisitionItems.splice(
                itemIndex,
                1
              );
              if (
                this.tableData[requisitionIndex].requisitionItems.length == 0
              ) {
                this.tableData.splice(requisitionIndex, 1);
              }
              this.showToast("Successfully set", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be set!", "error");
            });
        }
      });
    },
    assignToAllEmployee(row) {
      if (this.setAllEmployee) {
        this.formRequisition.forEach((item) => {
          item.endUserId = row.endUserId;
          item.employeeName = row.employeeName;
        });
      }
    },
    setToggle(items) {
      items.availableItems.forEach((item) => {
        item.toggleSelected = false;
      });
      if (items.toggleAll === true) {
        items.availableItems.forEach((item) => {
          item.toggleSelected = true;
        });
      }
    },
    checkItems(items) {
      var count = 0;
      items.availableItems.forEach((item) => {
        if (item.toggleSelected == true) {
          count++;
        }
      });
      if (count > 0) return true;
      else return false;
    },
    checkToggle(items) {
      var count = 0;
      items.availableItems.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count === items.availableItems.length) {
        items.toggleAll = true;
      } else {
        items.toggleAll = false;
      }
      this.$forceUpdate();
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    uploadedFiles() {},
    async getAttachments(row) {
      row.viewFile = true;
      row.attachmentLoading = true;
      row.requisitionFiles = [];
      var iarList = [];
      this.$forceUpdate();
      if (this.tabIndex != 0) {
        await this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: "Requisition",
            removeLoading: true
          })
          .then((res) => {
            res.data.forEach((item) => {
              row.requisitionFiles.push(item);
            });
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Getting documents!",
              "error"
            );
          });
        await this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.poId,
            type: "Purchase Order",
            removeLoading: true
          })
          .then((res) => {
            res.data.forEach((item) => {
              row.requisitionFiles.push(item);
            });
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Getting documents!",
              "error"
            );
          });
        await this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.iarId,
            type: "IAR",
            removeLoading: true
          })
          .then((res) => {
            res.data.forEach((item) => {
              row.requisitionFiles.push(item);
            });
            iarList.push(row.iarId);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Getting documents!",
              "error"
            );
          });
      } else {
        await this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.poId,
            type: "Purchase Order",
            removeLoading: true
          })
          .then((res) => {
            res.data.forEach((item) => {
              row.requisitionFiles.push(item);
            });
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Getting documents!",
              "error"
            );
          });
        await row.availableItems.forEach((items) => {
          if (!iarList.includes(items.iarId))
            this.$store
              .dispatch("filemanager/GetFiles", {
                id: items.iarId,
                type: "IAR",
                removeLoading: true
              })
              .then((res) => {
                res.data.forEach((item) => {
                  row.requisitionFiles.push(item);
                });
                iarList.push(items.iarId);
              })
              .catch(() => {
                this.showToast(
                  "Something went wrong - Getting documents!",
                  "error"
                );
              });
        });
      }
      await setTimeout(() => {
        row.attachmentLoading = false;
        this.$forceUpdate();
      }, 1000);
    },
    removeFile(id, parentId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex(
                (item) => item.id == parentId
              );
              let yIndex = this.tableData[index].requisitionFiles.findIndex(
                (item) => item.id == id
              );
              this.tableData[index].requisitionFiles.splice(yIndex, 1);
              this.$forceUpdate();
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async printRIS(id) {
      var apiUrl = `api/Report/Inspection/Requisition/RIS`;
      var routeVariables = [id];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    updateRSMIOption(opt){
      this.clearAllCart();
      if(opt == this.rsmiType) return;
      this.selectedItems = [];
      this.tableData.forEach(x => x.selected = false);
      this.tableData.map(req => {
        req.requisitionItems.map(item => {
          item.selected = false;
        })
      })
      this.rsmiType = opt;
    },
    async generateRSMI(data) {
      var apiUrl = `api/Report/Inspection/RSMI`;
      var body = {
        campusId: this.$store.state.data.selectedCampus.id,
        fundCluster: 0,
        poIds: [0],
        ids: [0]
      }
      if(data.type == 'cluster'){
        body.fundCluster = data.clusterId;
      }else if(data.type == 'po'){
        body.poIds = data.pos;
      }else{
        body.ids = data.items;
      }
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: [],
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async generateRSPI(data) {
      var apiUrl = `api/Report/Inspection/RSPI`;
      var body = {
        campusId: this.$store.state.data.selectedCampus.id,
        fundCluster: 0,
        poIds: [0],
        ids: [0]
      }
      if(data.type == 'cluster'){
        body.fundCluster = data.clusterId;
      }else if(data.type == 'po'){
        body.poIds = data.pos;
      }else{
        body.ids = data.items;
      }
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: [],
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    addToCart(item){
      item.selected = !item.selected;
      if(item.selected){
        this.selectedItems.push(item);
      }else{
        this.selectedItems.splice(this.selectedItems.findIndex(x => x.id == item.id), 1);
      }
    },
    selectPO(x){
      x.selected = !x.selected;
      if(x.selected){
        this.selectedPOs.push(x);
      }else{
        this.selectedPOs.splice(this.selectedPOs.findIndex(y => y.id == x.id), 1);
        console.log('yes')
      }
    },
    unCart(item){
      if(this.rsmiType === 'po'){
        let tabDat = this.tableData.find(x => x.id == item.id);
        if(tabDat){
          tabDat.selected = false;
        }
        this.selectedPOs.splice(this.selectedPOs.findIndex(x => x.id == item.id), 1);
      }else{
        this.selectedItems.splice(this.selectedItems.findIndex(x => x.id == item.id), 1);
      }
    },
    clearAllCart(){
      if(this.rsmiType === 'po'){
        this.selectedPOs.forEach(x => {
          let tabDat = this.tableData.find(y => y.id == x.id);
          if(tabDat){
            tabDat.selected = false;
          }
        });
        this.selectedPOs = [];
      }else{
        this.selectedItems = [];
      }
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <RequisitionModal 
      :modalTitle="modalTitle"
      ref="reqModal"
      from="supply"
      @submit="onCreate"
    />
    <PropertyModal
      :modalTitle="modalTitle"
      :itemCategory="itemCategory"
      ref="propModal"
      @submit="onCreateProperty"
    />
    <MergeStockModal 
      :modalTitle="modalTitle"
      ref="stockModal"
      @submit="onMergeStock"
    />
    <!-- Main -->
    <div class="position-relative">
      <b-tabs
        content-class="pt-3 pb-3 text-muted"
        v-model="tabIndex"
        nav-class="nav-tabs-custom"
      >
        <!-- Available -->
        <b-tab
          @click="
            getAvailable();
            perPage = 10;
            currentPage = 1;
            dateRangeIndex = -1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clock-time-four-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Available</span>
          </template>
          <div
            v-if="tabIndex == 0"
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0">List of Available Items</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div id="tickets-table_filter" class="dataTables_filter me-1">
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          placeholder="Search Item..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading" class="p-3 border">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-0">Loading...</h5>
                </div>
              </div>
              <div
                class="text-center border p-3"
                v-else-if="paginated.length == 0"
              >
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  items matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No items
                  available
                </div>
              </div>
              <div v-else class="text-muted border">
                <div
                  class="text-muted"
                  role="tablist"
                  v-for="(x, index) in paginated"
                  :key="x.id"
                >
                  <b-card
                    no-body
                    class="mb-0 border shadow-none position-relative"
                    style="min-width: fit-content"
                    :style="`z-index: ${paginated.length - index + 10}`"
                  >
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" :keyId="x.poId" />
                    <b-card-header
                      class="cursor-pointer"
                      @click="
                        x.visible = !x.visible;
                        $forceUpdate();
                      "
                    >
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div>
                          <b class="text-white">PO# {{ x.poNumber }}</b>
                          <div @click.stop>{{ x.deliveryUnit }}</div>
                          <div @click.stop><small>Processed By: <span class="text-green">{{ x.requestedBy }}</span></small></div>
                        </div>
                        <h5 class="mb-0">
                          <i
                            class="bx bx-chevron-right rotate"
                            :class="{
                              'rotate-90': x.visible
                            }"
                          ></i>
                        </h5>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :visible="x.visible"
                      :accordion="
                        `available-accordion-${x.poId}-${x.deliveryUnitId}`
                      "
                      role="tabpanel"
                    >
                      <b-card-body
                        v-if="x.visible"
                        class="border border-2 border-start-0 border-end-0"
                      >
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 250px">
                            <div>
                              <b class="font-size-14 me-1">Attachments:</b>
                              <a
                                href="javascript:void(0);"
                                @click="getAttachments(x)"
                                :id="
                                  `available-viewFiles-${x.poId}-${x.deliveryUnitId}`
                                "
                                >[Show attachments]</a
                              >
                              <b-popover
                                :target="
                                  `available-viewFiles-${x.poId}-${x.deliveryUnitId}`
                                "
                                triggers="click"
                                placement="right"
                                :show.sync="x.viewFile"
                                custom-class="popover-supplier"
                              >
                                <template v-slot:title>
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <small>Attachments</small>
                                    <span
                                      class="bx bx-x font-size-14 cursor-pointer"
                                      @click="
                                        x.viewFile = false;
                                        $forceUpdate();
                                      "
                                    ></span>
                                  </div>
                                </template>
                                <table
                                  class="table table-bordered"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length > 0
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionFiles"
                                      :key="y.id"
                                    >
                                      <td
                                        @click="openDocument(y)"
                                        class="hoverable-link cursor-pointer"
                                      >
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i
                                          v-if="
                                            isAdmin ||
                                              y.applicationUserId ==
                                                token.ApplicationUserId
                                          "
                                          @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"
                                        ></i>
                                        <i
                                          v-else
                                          class="bx bx-trash text-muted"
                                        ></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="text-center"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length == 0
                                  "
                                >
                                  No data found
                                </div>
                                <div
                                  v-if="x.attachmentLoading"
                                  class="text-center"
                                >
                                  <b-spinner
                                    variant="primary"
                                    label="Loading..."
                                  ></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                          </div>
                          <div
                            class="border-start border-3 ps-2"
                            style="width: 100%"
                          >
                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <b class="pt-2">Available Items:</b>
                              <div class="d-flex align-items-center">
                                <button
                                  v-if="checkItems(x)"
                                  type="button"
                                  @click="createRequisition(x)"
                                  class="btn btn-sm btn-primary d-flex align-items-center ms-1"
                                >
                                  <i class="bx bx-plus fs-6 me-1"></i>Create Requisition
                                </button>
                              </div>
                            </div>
                            <div
                              class="h-50vh d-flex align-items-center justify-content-center"
                              v-if="x.availableItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i>No
                                Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <div class="mb-2">
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2">Item Name</th>
                                      <th class="py-2" style="width: 200px">
                                        Accountable Officer
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 90px"
                                      >
                                        Qty
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 140px"
                                      >
                                        Unit Price
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 140px"
                                      >
                                        Total Price
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 60px"
                                      >
                                        <div
                                          class="d-flex justify-content-center"
                                          style="min-width: 35px"
                                        >
                                          <div
                                            class="form-check form-checkbox-outline form-check-success"
                                          >
                                            <input
                                              type="checkbox"
                                              :id="
                                                `checkbox-toggleAll-${x.poId}-${x.deliveryUnitId}`
                                              "
                                              checked="checked"
                                              class="form-check-input me-1"
                                              @change="setToggle(x)"
                                              v-model="x.toggleAll"
                                            /><label
                                              :for="
                                                `checkbox-toggleAll-${x.poId}-${x.deliveryUnitId}`
                                              "
                                              class="form-check-label"
                                            >
                                              All
                                            </label>
                                          </div>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.availableItems"
                                      :key="y.id"
                                      class="border-bottom"
                                    >
                                      <td class="py-2 align-top position-relative">
                                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                                        <div>{{ y.itemName }}</div>
                                        <small>{{ y.description }}</small>
                                      </td>
                                      <td class="py-2 align-top">
                                        {{ y.endUserName }}
                                      </td>
                                      <td
                                        class="py-2 align-top text-center text-info"
                                      >
                                        {{ y.availableQuantity }}
                                      </td>
                                      <td
                                        class="py-2 align-top text-center text-warning"
                                      >
                                        {{ formatCurrency(y.unitCost) }}
                                      </td>
                                      <td
                                        class="py-2 align-top text-center text-warning"
                                      >
                                        {{
                                          formatCurrency(
                                            y.availableQuantity * y.unitCost
                                          )
                                        }}
                                      </td>
                                      <td class="py-2 align-top">
                                        <div
                                          class="d-flex justify-content-center"
                                        >
                                          <div
                                            class="form-check form-checkbox-outline form-check-success"
                                          >
                                            <input
                                              type="checkbox"
                                              :id="
                                                `checkbox-${x.poId}-${x.deliveryUnitId}-${y.id}`
                                              "
                                              class="form-check-input"
                                              @change="checkToggle(x)"
                                              v-model="y.toggleSelected"
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="row mt-3">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Pending -->
        <b-tab
          @click="
            getPending();
            perPage = 10;
            currentPage = 1;
            dateRangeIndex = -1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clock-time-four-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Pending</span>
          </template>
          <div
            v-if="tabIndex == 1"
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0">List of Pending Items</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div id="tickets-table_filter" class="me-1">
                      <date-picker
                        ref="processedDateFilter"
                        style="width: 250px !important;"
                        v-model="processedDateFilter"
                        :first-day-of-week="1"
                        lang="en"
                        range
                        placeholder="Enter Date Range..."
                        :popupStyle="dateRangeIndex == 5 ? { right: 0 } : null"
                        @change="checkDate"
                      >
                        <div
                          v-if="processedDateFilter != ''"
                          slot="input"
                          class="form-control"
                        >
                          <div
                            v-if="
                              formatDateShort(new Date(processedDateFilter[0])) !=
                                formatDateShort(new Date(processedDateFilter[1]))
                            "
                          >
                            {{
                              formatDateShort(new Date(processedDateFilter[0]))
                            }}
                            -
                            {{
                              formatDateShort(new Date(processedDateFilter[1]))
                            }}
                          </div>
                          <div v-else>
                            {{ formatDate(new Date(processedDateFilter[0])) }}
                          </div>
                        </div>
                        <template v-slot:sidebar>
                          <div
                            @click="selectDate('Today')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 0
                            }"
                          >
                            Today
                          </div>
                          <div
                            @click="selectDate('Yesterday')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 1
                            }"
                          >
                            Yesterday
                          </div>
                          <div
                            @click="selectDate('Last 7 Days')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 2
                            }"
                          >
                            Last 7 Days
                          </div>
                          <div
                            @click="selectDate('This Month')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 3
                            }"
                          >
                            This Month
                          </div>
                          <div
                            @click="selectDate('This Year')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 4
                            }"
                          >
                            This Year
                          </div>
                          <div
                            @click="selectDate('Custom')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 5
                            }"
                          >
                            Custom
                          </div>
                        </template>
                        <template v-if="dateRangeIndex != 5" v-slot:content>
                          {{ null }}
                        </template>
                      </date-picker>
                    </div>
                    <div id="tickets-table_filter" class="dataTables_filter me-1">
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          placeholder="Search Item..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading" class="p-3 border">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-0">Loading...</h5>
                </div>
              </div>
              <div
                class="text-center border p-3"
                v-else-if="paginated.length == 0"
              >
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  items matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No items pending
                </div>
              </div>
              <div v-else class="text-muted border">
                <div>
                  <b-card
                    no-body
                    class="mb-0 border shadow-none"
                    style="min-width: fit-content"
                  >
                    <b-card-header>
                      <div class="d-flex justify-content-between">
                        <h6 class="text-muted m-0" style="min-width: 200px">
                          Requisition
                        </h6>
                        <h6
                          class="text-muted text-center m-0"
                          style="min-width: 100px"
                        >
                          Action
                        </h6>
                      </div>
                    </b-card-header>
                  </b-card>
                </div>
                <div
                  class="text-muted"
                  role="tablist"
                  v-for="(x, index) in paginated"
                  :key="x.id"
                >
                  <b-card
                    no-body
                    class="mb-0 border shadow-none"
                    :style="`z-index: ${paginated.length - index + 10}`"
                  >
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                    <b-card-header>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div style="min-width: 200px">
                          <div class="font-size-11">
                            PO#
                            {{ x.poNumber }}
                          </div>
                          <div class="d-flex align-items-center">
                            <div
                              class="d-flex align-items-center"
                              v-if="!x.editRISNo"
                            >
                              <b class="text-white">
                                Requisition# {{ x.requisitionNumber }}
                              </b>
                              <a
                                href="javascript:void(0);"
                                class="hover-max-width d-flex align-items-center ms-1"
                                @click="updateRISNumber(x)"
                              >
                                [Edit]
                              </a>
                            </div>
                            <div
                              class="d-flex align-items-center mb-1"
                              v-else-if="x.editRISNo"
                            >
                              <input
                                id="drNumber"
                                type="text"
                                v-model="x.risNumberEdit"
                                placeholder="Enter Requisition Number..."
                                class="form-control form-control-sm"
                                :class="{
                                  'is-invalid': submitted && x.risNumberEdit == ''
                                }"
                                autocomplete="off"
                              />
                              <button
                                type="button"
                                class="ms-1 btn btn-sm btn-success no-wrap"
                                @click="onUpdateRISNumber(x)"
                              >
                                <span><i class="bx bx-save me-1"></i>Save</span>
                              </button>
                              <button
                                type="button"
                                class="ms-1 btn btn-sm no-wrap btn-link"
                                @click="
                                  x.editRISNo = false;
                                  x.risNumberEdit = '';
                                "
                              >
                                <span>Cancel</span>
                              </button>
                            </div>
                          </div>
                          <div class="font-size-11 d-flex align-items-center">
                            <div>
                              {{
                                x.requisitionDate
                                  ? formatDate(new Date(x.requisitionDate))
                                  : null
                              }}
                            </div>
                            <div class="ms-1 me-1">|</div>
                            <div>
                              <a
                                href="javascript: void(0);"
                                class="text-success d-flex align-items-center"
                                @click="getRequisitionItems(x)"
                              >
                                {{ x.visible ? "Hide" : "Show" }}
                                Items
                                <i
                                  class="bx bx-chevron-right rotate font-size-14"
                                  :class="{
                                    'rotate-90': x.visible
                                  }"
                                ></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="text-center" style="min-width: 100px">
                          <i
                            title="Print RIS"
                            class="bx bx-printer font-size-18 text-purple cursor-pointer me-2"
                            @click="printRIS(x.id)"
                          ></i>
                          <i
                            title="Delete Item"
                            class="mdi mdi-trash-can-outline font-size-18 text-danger cursor-pointer me-2"
                            @click="onDelete(x.id)"
                          ></i>
                          <i
                            title="Approve Item"
                            class="mdi mdi-check-underline font-size-18 text-success cursor-pointer"
                            @click="onApprove(x.id)"
                          ></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :visible="x.visible"
                      :accordion="`pending-accordion-${x.id}`"
                      role="tabpanel"
                    >
                      <b-card-body
                        v-if="x.visible"
                        class="border border-2 border-start-0 border-end-0 custom-table-responsive"
                      >
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 250px">
                            <div>
                              <b class="font-size-14 me-1">Attachments:</b>
                              <a
                                href="javascript:void(0);"
                                @click="getAttachments(x)"
                                :id="`pending-viewFiles-${x.id}`"
                                >[Show attachments]</a
                              >
                              <b-popover
                                :target="`pending-viewFiles-${x.id}`"
                                triggers="click"
                                placement="right"
                                :show.sync="x.viewFile"
                                custom-class="popover-supplier"
                              >
                                <template v-slot:title>
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <small>Attachments</small>
                                    <span
                                      class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"
                                    ></span>
                                  </div>
                                </template>
                                <table
                                  class="table table-bordered"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length > 0
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionFiles"
                                      :key="y.id"
                                    >
                                      <td
                                        @click="openDocument(y)"
                                        class="hoverable-link cursor-pointer"
                                      >
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i
                                          v-if="
                                            isAdmin ||
                                              y.applicationUserId ==
                                                token.ApplicationUserId
                                          "
                                          @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"
                                        ></i>
                                        <i
                                          v-else
                                          class="bx bx-trash text-muted"
                                        ></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="text-center"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length == 0
                                  "
                                >
                                  No data found
                                </div>
                                <div
                                  v-if="x.attachmentLoading"
                                  class="text-center"
                                >
                                  <b-spinner
                                    variant="primary"
                                    label="Loading..."
                                  ></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div class="mt-2">
                              <button
                                :id="`pending-document${x.id}`"
                                type="button"
                                class="btn btn-sm btn-outline-success"
                                @click="x.addDocu = true"
                              >
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover
                                :option="uploadOptions"
                                :sourceId="x.id"
                                @uploaded="uploadedFiles"
                                :showPV="x.addDocu"
                                @closePopover="x.addDocu = false"
                                :dzId="`dropzone-pending${x.id}`"
                                :pvId="`pending-document${x.id}`"
                              ></upload-popover>
                            </div>
                          </div>
                          <div
                            class="border-start border-3 ps-2"
                            style="width: 100%"
                          >
                            <div
                              v-if="x.loading"
                              class="my-3 d-flex align-items-center justify-content-center"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <h5 class="mb-0">Loading...</h5>
                            </div>
                            <div
                              class="my-3 d-flex align-items-center justify-content-center"
                              v-else-if="x.requisitionItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i>No
                                Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <div class="mb-2">
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2">Item Name</th>
                                      <th class="py-2" style="width: 200px">
                                        Warehouse Location
                                      </th>
                                      <th class="py-2" style="width: 200px">
                                        Accountable Officer
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 90px"
                                      >
                                        Qty
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 140px"
                                      >
                                        Unit Price
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 140px"
                                      >
                                        Total Price
                                      </th>
                                      <th
                                        class="py-2 text-center"
                                        style="width: 60px"
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionItems"
                                      :key="y.id"
                                      class="border-bottom"
                                    >
                                      <td class="py-2 align-top position-relative">
                                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                                        {{ y.itemName }}
                                        <small class="d-block">{{y.description}}</small>
                                        <small class="d-block text-warning">{{y.itemCategory}}</small>
                                      </td>
                                      <td class="py-2 align-top">
                                        {{ y.locationArea }}
                                      </td>
                                      <td class="py-2 align-top">
                                        {{ y.endUser }}
                                      </td>
                                      <td
                                        class="py-2 align-top text-center text-info"
                                      >
                                        {{ y.quantity }}
                                      </td>
                                      <td
                                        class="py-2 align-top text-center text-warning"
                                      >
                                        {{ formatCurrency(y.unitCost) }}
                                      </td>
                                      <td
                                        class="py-2 align-top text-center text-warning"
                                      >
                                        {{ formatCurrency(y.totalCost) }}
                                      </td>
                                      <td
                                        style="min-width: 60px"
                                        class="py-1 align-top text-center"
                                      >
                                        <i
                                          title="Update Item"
                                          class="mdi mdi-circle-edit-outline font-size-18 text-info cursor-pointer"
                                          @click="updateRequisition(y, x.id)"
                                        ></i>
                                        <i
                                          v-if="$store.state.decrypt.isAdmin()"
                                          title="Remove Item"
                                          class="mdi mdi-trash-can-outline font-size-18 text-danger cursor-pointer"
                                          @click="removeRequisition(y, x.id)"
                                        ></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="row mt-3">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Approved -->
        <b-tab
          @click="
            getApproved();
            perPage = 10;
            currentPage = 1;
            dateRangeIndex = -1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-check-circle-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Approved</span>
          </template>
          <div
            v-if="tabIndex == 2"
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0">List of Approved Items</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div class="me-1">
                      <date-picker
                        ref="processedDateFilter"
                        style="width: 250px !important;"
                        v-model="processedDateFilter"
                        :first-day-of-week="1"
                        lang="en"
                        range
                        placeholder="Enter Date Range..."
                        :popupStyle="dateRangeIndex == 5 ? { right: 0 } : null"
                        @change="checkDate"
                      >
                        <div
                          v-if="processedDateFilter != ''"
                          slot="input"
                          class="form-control"
                        >
                          <div
                            v-if="
                              formatDateShort(new Date(processedDateFilter[0])) !=
                                formatDateShort(new Date(processedDateFilter[1]))
                            "
                          >
                            {{
                              formatDateShort(new Date(processedDateFilter[0]))
                            }}
                            -
                            {{
                              formatDateShort(new Date(processedDateFilter[1]))
                            }}
                          </div>
                          <div v-else>
                            {{ formatDate(new Date(processedDateFilter[0])) }}
                          </div>
                        </div>
                        <template v-slot:sidebar>
                          <div
                            @click="selectDate('Today')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 0
                            }"
                          >
                            Today
                          </div>
                          <div
                            @click="selectDate('Yesterday')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 1
                            }"
                          >
                            Yesterday
                          </div>
                          <div
                            @click="selectDate('Last 7 Days')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 2
                            }"
                          >
                            Last 7 Days
                          </div>
                          <div
                            @click="selectDate('This Month')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 3
                            }"
                          >
                            This Month
                          </div>
                          <div
                            @click="selectDate('This Year')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 4
                            }"
                          >
                            This Year
                          </div>
                          <div
                            @click="selectDate('Custom')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 5
                            }"
                          >
                            Custom
                          </div>
                        </template>
                        <template v-if="dateRangeIndex != 5" v-slot:content>
                          {{ null }}
                        </template>
                      </date-picker>
                    </div>
                    <label class="align-items-center me-1 mb-0">
                      <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search Item..."
                        class="form-control"
                      ></b-form-input>
                    </label>
                    <label class="align-items-center mb-0">
                      <b-form-select
                        class="form-select"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      >
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="loading" class="p-3 border">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-0">Loading...</h5>
                </div>
              </div>
              <div
                class="text-center border p-3"
                v-else-if="paginated.length == 0"
              >
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  items matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No items
                  approved
                </div>
              </div>
              <div v-else class="text-muted border">
                <div>
                  <b-card
                    no-body
                    class="mb-0 border shadow-none"
                    style="min-width: fit-content"
                  >
                    <b-card-header>
                      <div class="d-flex justify-content-between">
                        <h6 class="text-muted m-0" style="min-width: 200px">
                          Requisition
                        </h6>
                        <h6
                          class="text-muted text-center m-0"
                          style="min-width: 100px"
                        >
                          Action
                        </h6>
                      </div>
                    </b-card-header>
                  </b-card>
                </div>
                <div
                  class="text-muted"
                  role="tablist"
                  v-for="(x, index) in paginated"
                  :key="x.id"
                >
                  <b-card
                    no-body
                    class="mb-0 border shadow-none"
                    :style="`z-index: ${paginated.length - index + 10}`"
                  >
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                    <b-card-header>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div style="min-width: 200px">
                          <div class="font-size-11">
                            PO#
                            {{ x.poNumber }}
                          </div>
                          <b class="text-white">
                            Requisition# {{ x.requisitionNumber }}
                          </b>
                          <div class="font-size-11 d-flex align-items-center">
                            <div>
                              {{
                                x.requisitionDate
                                  ? formatDate(new Date(x.requisitionDate))
                                  : null
                              }}
                            </div>
                            <div class="ms-1 me-1">|</div>
                            <div>
                              <a
                                href="javascript: void(0);"
                                class="text-success d-flex align-items-center"
                                @click="getRequisitionItems(x)"
                              >
                                {{ x.visible ? "Hide" : "Show" }}
                                Items
                                <i
                                  class="bx bx-chevron-right rotate font-size-14"
                                  :class="{
                                    'rotate-90': x.visible
                                  }"
                                ></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="text-center" style="min-width: 100px">
                          <i
                            title="Add to Cart"
                            class="mdi font-size-18 cursor-pointer me-2"
                            :class="{'mdi-cart-outline text-info': !x.selected, 'mdi-cart-remove text-danger': x.selected}"
                            @click="selectPO(x)"
                            v-if="rsmiType === 'po'"
                          ></i>
                          <i
                            title="Print RIS"
                            class="bx bx-printer font-size-18 text-purple cursor-pointer me-2"
                            @click="printRIS(x.id)"
                          ></i>
                          <i
                            title="Undo Approve"
                            class="mdi mdi-undo-variant font-size-18 text-warning cursor-pointer"
                            @click="undoApprove(x.id)"
                          ></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :visible="x.visible"
                      :accordion="`approved-accordion-${x.id}`"
                      role="tabpanel"
                    >
                      <b-card-body
                        v-if="x.visible"
                        class="border border-2 border-start-0 border-end-0 custom-table-responsive"
                      >
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 250px">
                            <div>
                              <b class="font-size-14 me-1">Attachments:</b>
                              <a
                                href="javascript:void(0);"
                                @click="getAttachments(x)"
                                :id="`approved-viewFiles-${x.id}`"
                                >[Show attachments]</a
                              >
                              <b-popover
                                :target="`approved-viewFiles-${x.id}`"
                                triggers="click"
                                placement="right"
                                :show.sync="x.viewFile"
                                custom-class="popover-supplier"
                              >
                                <template v-slot:title>
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <small>Attachments</small>
                                    <span
                                      class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"
                                    ></span>
                                  </div>
                                </template>
                                <table
                                  class="table table-bordered"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length > 0
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionFiles"
                                      :key="y.id"
                                    >
                                      <td
                                        @click="openDocument(y)"
                                        class="hoverable-link cursor-pointer"
                                      >
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i
                                          v-if="
                                            isAdmin ||
                                              y.applicationUserId ==
                                                token.ApplicationUserId
                                          "
                                          @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"
                                        ></i>
                                        <i
                                          v-else
                                          class="bx bx-trash text-muted"
                                        ></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="text-center"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length == 0
                                  "
                                >
                                  No data found
                                </div>
                                <div
                                  v-if="x.attachmentLoading"
                                  class="text-center"
                                >
                                  <b-spinner
                                    variant="primary"
                                    label="Loading..."
                                  ></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div class="mt-2">
                              <button
                                :id="`approved-document${x.id}`"
                                type="button"
                                class="btn btn-sm btn-outline-success"
                                @click="x.addDocu = true"
                              >
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover
                                :option="uploadOptions"
                                :sourceId="x.id"
                                @uploaded="uploadedFiles"
                                :showPV="x.addDocu"
                                @closePopover="x.addDocu = false"
                                :dzId="`dropzone-approved${x.id}`"
                                :pvId="`approved-document${x.id}`"
                              ></upload-popover>
                            </div>
                          </div>
                          <div
                            class="border-start border-3 ps-2"
                            style="width: 100%"
                          >
                            <div
                              v-if="x.loading"
                              class="my-3 d-flex align-items-center justify-content-center"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <h5 class="mb-0">Loading...</h5>
                            </div>
                            <div
                              class="my-3 d-flex align-items-center justify-content-center"
                              v-else-if="x.requisitionItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i>No
                                Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <table width="100%">
                                <thead>
                                  <tr class="border-bottom">
                                    <th class="py-2">Item Name</th>
                                    <th class="py-2" style="width: 200px">
                                      Warehouse Location
                                    </th>
                                    <th class="py-2" style="width: 200px">
                                      Accountable Officer
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 90px"
                                    >
                                      Qty
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 140px"
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 140px"
                                    >
                                      Total Price
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 120px"
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="y in x.requisitionItems"
                                    :key="y.id"
                                    class="border-bottom"
                                  >
                                    <td class="py-2 align-top position-relative">
                                      <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                                      {{ y.itemName }}
                                      <small class="d-block">{{y.description}}</small>
                                      <small class="d-block text-warning">{{y.itemCategory}}</small>
                                    </td>
                                    <td class="py-2 align-top">
                                      {{ y.locationArea }}
                                    </td>
                                    <td class="py-2 align-top">
                                      {{ y.endUser }}
                                    </td>
                                    <td
                                      class="py-2 align-top text-center text-info"
                                    >
                                      {{ y.quantity }}
                                    </td>
                                    <td
                                      class="py-2 align-top text-center text-warning"
                                    >
                                      {{ formatCurrency(y.unitCost) }}
                                    </td>
                                    <td
                                      class="py-2 align-top text-center text-warning"
                                    >
                                      {{ formatCurrency(y.totalCost) }}
                                    </td>
                                    <td
                                      style="min-width: 60px"
                                      class="py-1 align-top text-center"
                                    >
                                      <i
                                        title="Add to Cart"
                                        class="mdi mdi-cart font-size-18 text-warning cursor-pointer me-2"
                                        :class="{'mdi-cart-outline text-warning': !y.selected, 'mdi-cart-remove text-danger': y.selected}"
                                        v-if="rsmiType === 'items'"
                                        @click="addToCart(y)"
                                      ></i>
                                      <i
                                        title="Set as Services/Consumable"
                                        class="mdi mdi-silverware font-size-18 text-success cursor-pointer me-2"
                                        @click="setServices(y, x)"
                                      ></i>
                                      <i
                                        title="Add to Stock"
                                        class="mdi mdi-database-check-outline font-size-18 text-success cursor-pointer me-2"
                                        @click="mergeStock(y, x)"
                                      ></i>
                                      <i
                                        title="Create Property"
                                        class="mdi mdi-credit-card-check-outline font-size-18 text-success cursor-pointer"
                                        @click="createProperty(y, x)"
                                      ></i>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="row mt-3">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Completed -->
        <b-tab
          @click="
            getCompleted();
            perPage = 10;
            currentPage = 1;
            dateRangeIndex = -1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-check-circle-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Completed</span>
          </template>
          <div
            v-if="tabIndex == 3"
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0">List of Completed Items</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div id="tickets-table_filter" class="me-1">
                      <date-picker
                        ref="processedDateFilter"
                        style="width: 250px !important;"
                        v-model="processedDateFilter"
                        :first-day-of-week="1"
                        lang="en"
                        range
                        placeholder="Enter Date Range..."
                        :popupStyle="
                          dateRangeIndex == 5 ? { right: 0, width: 400 } : null
                        "
                        @change="checkDate"
                      >
                        <div
                          v-if="processedDateFilter != ''"
                          slot="input"
                          class="form-control"
                        >
                          <div
                            v-if="
                              formatDateShort(new Date(processedDateFilter[0])) !=
                                formatDateShort(new Date(processedDateFilter[1]))
                            "
                          >
                            {{
                              formatDateShort(new Date(processedDateFilter[0]))
                            }}
                            -
                            {{
                              formatDateShort(new Date(processedDateFilter[1]))
                            }}
                          </div>
                          <div v-else>
                            {{ formatDate(new Date(processedDateFilter[0])) }}
                          </div>
                        </div>
                        <template v-slot:sidebar>
                          <div
                            @click="selectDate('Today')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 0
                            }"
                          >
                            Today
                          </div>
                          <div
                            @click="selectDate('Yesterday')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 1
                            }"
                          >
                            Yesterday
                          </div>
                          <div
                            @click="selectDate('Last 7 Days')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 2
                            }"
                          >
                            Last 7 Days
                          </div>
                          <div
                            @click="selectDate('This Month')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 3
                            }"
                          >
                            This Month
                          </div>
                          <div
                            @click="selectDate('This Year')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 4
                            }"
                          >
                            This Year
                          </div>
                          <div
                            @click="selectDate('Custom')"
                            class="py-1 px-2 cursor-pointer"
                            :class="{
                              'date-range-selected': dateRangeIndex == 5
                            }"
                          >
                            Custom
                          </div>
                        </template>
                        <template v-if="dateRangeIndex != 5" v-slot:content>
                          {{ null }}
                        </template>
                      </date-picker>
                    </div>
                    <div id="tickets-table_filter" class="dataTables_filter me-1">
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          placeholder="Search Item..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading" class="p-3 border">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-0">Loading...</h5>
                </div>
              </div>
              <div
                class="text-center border p-3"
                v-else-if="paginated.length == 0"
              >
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  items matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No items
                  completed
                </div>
              </div>
              <div v-else class="text-muted border">
                <div>
                  <b-card
                    no-body
                    class="mb-0 border shadow-none"
                    style="min-width: fit-content"
                  >
                    <b-card-header>
                      <div class="d-flex justify-content-between">
                        <h6 class="text-muted m-0" style="min-width: 200px">
                          Requisition
                        </h6>
                        <h6
                          class="text-muted text-center m-0"
                          style="min-width: 100px"
                        >
                          Action
                        </h6>
                      </div>
                    </b-card-header>
                  </b-card>
                </div>
                <div
                  class="text-muted"
                  role="tablist"
                  v-for="(x, index) in paginated"
                  :key="x.id"
                >
                  <b-card
                    no-body
                    class="mb-0 border shadow-none"
                    :style="`z-index: ${paginated.length - index + 10}`"
                  >
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                    <b-card-header>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div style="min-width: 200px">
                          <div class="font-size-11">
                            PO#
                            {{ x.poNumber }}
                          </div>
                          <b class="text-white">
                            Requisition# {{ x.requisitionNumber }}
                          </b>
                          <div class="font-size-11 d-flex align-items-center">
                            <div>
                              {{
                                x.requisitionDate
                                  ? formatDate(new Date(x.requisitionDate))
                                  : null
                              }}
                            </div>
                            <div class="ms-1 me-1">|</div>
                            <div>
                              <a
                                href="javascript: void(0);"
                                class="text-success d-flex align-items-center"
                                @click="getRequisitionItems(x)"
                              >
                                {{ x.visible ? "Hide" : "Show" }}
                                Items
                                <i
                                  class="bx bx-chevron-right rotate font-size-14"
                                  :class="{
                                    'rotate-90': x.visible
                                  }"
                                ></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="text-center" style="min-width: 100px">
                          <i
                            title="Add to Cart"
                            class="mdi font-size-18 cursor-pointer me-2"
                            :class="{'mdi-cart-outline text-info': !x.selected, 'mdi-cart-remove text-danger': x.selected}"
                            @click="selectPO(x)"
                            v-if="rsmiType === 'po'"
                          ></i>
                          <i
                            title="Print RIS"
                            class="bx bx-printer font-size-18 text-purple cursor-pointer"
                            @click="printRIS(x.id)"
                          ></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :visible="x.visible"
                      :accordion="`completed-accordion-${x.id}`"
                      role="tabpanel"
                    >
                      <b-card-body
                        v-if="x.visible"
                        class="border border-2 border-start-0 border-end-0 custom-table-responsive"
                      >
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 250px">
                            <div>
                              <b class="font-size-14 me-1">Attachments:</b>
                              <a
                                href="javascript:void(0);"
                                @click="getAttachments(x)"
                                :id="`completed-viewFiles-${x.id}`"
                                >[Show attachments]</a
                              >
                              <b-popover
                                :target="`completed-viewFiles-${x.id}`"
                                triggers="click"
                                placement="right"
                                :show.sync="x.viewFile"
                                custom-class="popover-supplier"
                              >
                                <template v-slot:title>
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <small>Attachments</small>
                                    <span
                                      class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"
                                    ></span>
                                  </div>
                                </template>
                                <table
                                  class="table table-bordered"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length > 0
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionFiles"
                                      :key="y.id"
                                    >
                                      <td
                                        @click="openDocument(y)"
                                        class="hoverable-link cursor-pointer"
                                      >
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i
                                          v-if="
                                            isAdmin ||
                                              y.applicationUserId ==
                                                token.ApplicationUserId
                                          "
                                          @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"
                                        ></i>
                                        <i
                                          v-else
                                          class="bx bx-trash text-muted"
                                        ></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="text-center"
                                  v-if="
                                    !x.attachmentLoading &&
                                      x.requisitionFiles.length == 0
                                  "
                                >
                                  No data found
                                </div>
                                <div
                                  v-if="x.attachmentLoading"
                                  class="text-center"
                                >
                                  <b-spinner
                                    variant="primary"
                                    label="Loading..."
                                  ></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div class="mt-2">
                              <button
                                :id="`completed-document${x.id}`"
                                type="button"
                                class="btn btn-sm btn-outline-success"
                                @click="x.addDocu = true"
                              >
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover
                                :option="uploadOptions"
                                :sourceId="x.id"
                                @uploaded="uploadedFiles"
                                :showPV="x.addDocu"
                                @closePopover="x.addDocu = false"
                                :dzId="`dropzone-completed${x.id}`"
                                :pvId="`completed-document${x.id}`"
                              ></upload-popover>
                            </div>
                          </div>
                          <div
                            class="border-start border-3 ps-2"
                            style="width: 100%"
                          >
                            <div
                              v-if="x.loading"
                              class="my-3 d-flex align-items-center justify-content-center"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <h5 class="mb-0">Loading...</h5>
                            </div>
                            <div
                              class="my-3 d-flex align-items-center justify-content-center"
                              v-else-if="x.requisitionItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i>No
                                Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <table width="100%">
                                <thead>
                                  <tr class="border-bottom">
                                    <th class="py-2">Item Name</th>
                                    <th class="py-2" style="width: 200px">
                                      Warehouse Location
                                    </th>
                                    <th class="py-2" style="width: 200px">
                                      Accountable Officer
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 90px"
                                    >
                                      Qty
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 140px"
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      class="py-2 text-center"
                                      style="width: 140px"
                                    >
                                      Total Price
                                    </th>
                                    <th v-if="rsmiType === 'items'" style="width: 50px"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="y in x.requisitionItems"
                                    :key="y.id"
                                    class="border-bottom"
                                  >
                                    <td class="py-2 align-top position-relative">
                                      <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                                      {{ y.itemName }}
                                      <small class="d-block">{{y.description}}</small>
                                      <small class="d-block text-warning">{{y.itemCategory}}</small>
                                    </td>
                                    <td class="py-2 align-top">
                                      {{ y.locationArea }}
                                    </td>
                                    <td class="py-2 align-top">
                                      {{ y.endUser }}
                                    </td>
                                    <td
                                      class="py-2 align-top text-center text-info"
                                    >
                                      {{ y.quantity }}
                                    </td>
                                    <td
                                      class="py-2 align-top text-center text-warning"
                                    >
                                      {{ formatCurrency(y.unitCost) }}
                                    </td>
                                    <td
                                      class="py-2 align-top text-center text-warning"
                                    >
                                      {{ formatCurrency(y.totalCost) }}
                                    </td>
                                    <td v-if="rsmiType === 'items'">
                                        <i
                                          title="Add to Cart"
                                          class="mdi mdi-cart font-size-18 text-warning cursor-pointer me-2"
                                          :class="{'mdi-cart-outline text-warning': !y.selected, 'mdi-cart-remove text-danger': y.selected}"
                                          @click="addToCart(y)"
                                        ></i>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="row mt-3">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div class="position-absolute" :style="{'top': 0, 'right': 0}" v-if="tabIndex == 2 || tabIndex == 3">
        <RSMIGeneration 
          class="me-1" 
          type="button"
          :fundclusters="fundclusters" 
          @generate-rsmi="generateRSMI"
          @generate-rspi="generateRSPI"
          @update-option="updateRSMIOption($event)"
        />
      </div>
    </div>
    <print-options ref="printOpt"></print-options>
    <RSMIGeneration 
      class="me-1" 
      type="cart"
      :selectedPOs="selectedPOs"
      :selectedItems="selectedItems"
      @generate-rsmi="generateRSMI"
      @generate-rspi="generateRSPI"
      @uncart="unCart"
      @clear-all="clearAllCart"
    />
  </Layout>
</template>

<style>
.mx-datepicker-sidebar {
  padding: 0;
}

.date-range-selected {
  background: #1284e7;
  color: #fff;
}
</style>
